import { Link } from "react-router-dom";
import Breadcrumbs from "./breadcrumbs";
import { msalInstance } from "src/lib/msal";

const handleSignOut = async () => {
    await msalInstance.logoutRedirect({
        postLogoutRedirectUri: "/",
    });
};

export default function Header() {
    return (
        <div className="navbar bg-gray-700 text-neutral-content">
            <Link to="/">
                <img src="/mvtRotate.gif" className="h-10" />
            </Link>

            <button className="mvte-center-link">
                <Link to="/">MVTE Center</Link>
            </button>
            <Breadcrumbs></Breadcrumbs>
            <button
                className="btn btn-ghost btn-md ml-auto"
                onClick={handleSignOut}
            >
                Logout
            </button>
        </div>
    );
}
